/* ============================================================
   TMPG — Shared media gallery + fullscreen lightbox
   One implementation used by the standard product template and the Archive
   Record template. Initialises every [data-tmpg-gallery] stage on the page and
   exposes window.TMPGGallery[sid] = { show, open, close } so a consuming section
   (e.g. variant switching) can drive the active image.
   ============================================================ */
(function () {
  'use strict';
  window.TMPGGallery = window.TMPGGallery || {};

  function initGallery(slidesEl) {
    var sid = slidesEl.getAttribute('data-sid');
    if (!sid || window.TMPGGallery[sid]) return;

    var thumbsEl  = document.getElementById('tp-thumbs-' + sid);
    var lb        = document.getElementById('tp-lightbox-' + sid);
    var lbImg     = document.getElementById('tp-lb-img-' + sid);
    var lbClose   = document.getElementById('tp-lb-close-' + sid);
    var lbPrev    = document.getElementById('tp-lb-prev-' + sid);
    var lbNext    = document.getElementById('tp-lb-next-' + sid);
    var lbCounter = document.getElementById('tp-lb-counter-' + sid);
    var lbIdx = 0;

    function slides() { return Array.prototype.slice.call(slidesEl.querySelectorAll('.tp-media__slide')); }

    function showSlide(idx) {
      var s = slides();
      if (!s.length) return;
      idx = Math.max(0, Math.min(idx, s.length - 1));
      s.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      if (thumbsEl) thumbsEl.querySelectorAll('.tp-thumb').forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }

    if (thumbsEl) thumbsEl.querySelectorAll('.tp-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () { showSlide(parseInt(this.dataset.index, 10)); });
    });

    /* Fullscreen lightbox */
    function lbShow(idx) {
      var s = slides();
      if (!s.length || !lb) return;
      idx = ((idx % s.length) + s.length) % s.length;
      lbIdx = idx;
      var slide = s[idx];
      var img = slide.querySelector('img');
      if (lbImg) {
        lbImg.src = slide.getAttribute('data-full') || (img ? img.src : '');
        lbImg.alt = slide.getAttribute('data-alt') || '';
      }
      if (lbCounter) lbCounter.textContent = (idx + 1) + ' / ' + s.length;
      var multi = s.length > 1;
      if (lbPrev) lbPrev.style.display = multi ? '' : 'none';
      if (lbNext) lbNext.style.display = multi ? '' : 'none';
    }
    function lbOpen(idx) { if (!lb) return; lbShow(idx); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function lbCloseFn() { if (!lb) return; lb.classList.remove('is-open'); document.body.style.overflow = ''; if (lbImg) lbImg.src = ''; }

    slidesEl.querySelectorAll('.tp-media__slide img').forEach(function (img, i) {
      img.addEventListener('click', function () { lbOpen(i); });
    });
    if (lbClose) lbClose.addEventListener('click', lbCloseFn);
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg) lbCloseFn(); });
    if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIdx - 1); });
    if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIdx + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbCloseFn();
      else if (e.key === 'ArrowLeft')  lbShow(lbIdx - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
    });

    /* Touch swipe inside the fullscreen viewer (mobile) */
    if (lb) {
      var tx = 0;
      lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) { if (dx < 0) lbShow(lbIdx + 1); else lbShow(lbIdx - 1); }
      }, { passive: true });
    }

    window.TMPGGallery[sid] = { show: showSlide, open: lbOpen, close: lbCloseFn };
  }

  function initAll() { document.querySelectorAll('[data-tmpg-gallery]').forEach(initGallery); }
  /* Run now (script is placed after the gallery markup) and again on DOM ready as a fallback. */
  initAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
}());
